import { INITIALIZATION_ERROR, NAVIGATION, REDIRECTION } from './types';
const initialState = {
  location: '',
  previousLocation: '',
  query: {},
  queryString: '',
  redirection: ''
};
export const navReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        previousLocation: state.location,
        location: action.context.canonicalPath.split('?')[0].replace(/\/$/, '').toLowerCase(),
        query: action.context.query || state.query
      };
    case REDIRECTION:
      return {
        ...state,
        redirection: action.redirect
      };
    case INITIALIZATION_ERROR:
      return {
        ...state,
        initErrorStatus: action.initErrorStatus,
        initErrorCode: action.initErrorCode,
        redirect_uri: action.redirect_uri
      };
    default:
      return state;
  }
};